function toggleElement(eleId) {
    let x = document.getElementById(eleId);
    if (x.nodeName == "table") {
        if (x.style.display === "none") {
            x.style.display = "table";
        } else {
            x.style.display = "none";
        }
    }
    else {
        if (x.style.display === "none") {
            x.style.display = "block";
        } else {
            x.style.display = "none";
        }
    }
}

function changeActiveLetter(newActiveLetter) {
    toShow = document.getElementsByName(`tr+${newActiveLetter}`)
    if (newActiveLetter.startsWith("My")){
        rows = document.querySelectorAll("[id^='tr+My'] ");
    } else {
        rows = document.querySelectorAll("[id^='tr+Other']");
    }
    rows.forEach(row => {
        row.style.display = "none";
    })
    //toShow.style.display = "table-row"
	for (i = 0; i < toShow.length; i++) {
	  toShow[i].style.display = "table-row"
	}
}

document.addEventListener('turbolinks:load', () => {
    const clickButtons = document.querySelectorAll(".toggler");
    clickButtons.forEach(clickButton => {
        clickButton.addEventListener('click', (event) => {
            event.preventDefault ? event.preventDefault() : event.returnValue = false;
            toggleElement(clickButton.dataset.toggle)
        });
    })
    const letterSelectors = document.querySelectorAll(".set-active-letter");
    letterSelectors.forEach(letterSelector => {
        letterSelector.addEventListener('click', (event) => {
            event.preventDefault ? event.preventDefault() : event.returnValue = false;
            changeActiveLetter(letterSelector.dataset.letter)
        });
    })
});